import PropTypes from '../../../utils/propTypes';

export const Table = ({ children, width, style }) => {
  return (
    <table
      style={{
        backgroundColor: 'rgb(255, 255, 255)',
        fontSize: '15px',
        width: width,
        paddingRight: '20px',
        textAlign: 'center',
        ...style,
      }}
    >
      <tbody id="AccionaTableBody">{children}</tbody>
    </table>
  );
};

Table.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.any),
  ]).isRequired,
  width: PropTypes.string,
  style: PropTypes.object,
};

Table.defaultProps = {
  style: {},
  width: undefined,
};
